<template>
  <div class="alert-box" :class="levelModifier">
    <div class="alert-box__title" v-if="!!$slots.title">
      <slot name="title"></slot>
    </div>
    <div class="alert-box__content">
      <img class="alert-box__content-icon" v-if="iconSrc" :src="iconSrc" />
      <div class="alert-box__content-text">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script src="./alert-box.js"></script>
<style src="./alert-box.scss" lang="scss"></style>
